import { createSelector } from 'reselect';
import { collapseShadeSelectorsSelector } from 'selectors/testTarget/offers/collapseShadeSelectors/collapseShadeSelectorsSelector';

const showSelector = createSelector(collapseShadeSelectorsSelector, collapseShadeSelectors => !!collapseShadeSelectors.show);

export { showSelector };
